import api from './api';

const d = (r) => r.data;
const form = (file, fields) => {
  const f = new FormData();
  f.append('file', file);
  Object.entries(fields).forEach(([k, v]) => v != null && v !== '' && f.append(k, v));
  return f;
};

export const taxBasAPI = {
  // phase 2 – workflow
  irCreate: (body) => api.post('/api/workflow/info-requests', body).then(d),
  irReceived: (id) => api.post(`/api/workflow/info-requests/${id}/received`).then(d),
  irRemind: (id) => api.post(`/api/workflow/info-requests/${id}/remind`).then(d),
  irReply: (id, body) => api.post(`/api/portal/workflow/info-requests/${id}/reply`, { body }).then(d),
  irUpload: (id, file, f = {}) => api.post(`/api/portal/workflow/info-requests/${id}/upload`, form(file, f)).then(d),
  clAdd: (kind, ref, label) => api.post(`/api/workflow/checklists/${kind}/${ref}/items`, { label }).then(d),
  clRemove: (kind, ref, key) => api.delete(`/api/workflow/checklists/${kind}/${ref}/items/${key}`).then(d),
  clRestore: (kind, ref, key) => api.post(`/api/workflow/checklists/${kind}/${ref}/items/${key}/restore`).then(d),
  itDeadline: (tid, body) => api.put(`/api/workflow/income-tax/${tid}/deadline`, body).then(d),
  dash: (params) => api.get('/api/workflow/tax-bas', { params }).then(d),
  clientSummary: () => api.get('/api/portal/workflow/summary').then(d),
  bulkPreview: (body) => api.post('/api/workflow/tax-bas/bulk/preview', body).then(d),
  bulkSend: (id) => api.post(`/api/workflow/tax-bas/bulk/${id}/send`).then(d),
  // client portal – income tax
  itList: () => api.get('/api/portal/income-tax').then(d),
  itStart: (cid, fy) => api.post(`/api/portal/income-tax/${cid}/start`, { financial_year: fy }).then(d),
  itGet: (id) => api.get(`/api/portal/income-tax/returns/${id}`).then(d),
  itSave: (id, body) => api.put(`/api/portal/income-tax/returns/${id}/answers`, body).then(d),
  itUpload: (id, file, fields) => api.post(`/api/portal/income-tax/returns/${id}/upload`, form(file, fields)).then(d),
  itSubmit: (id, version) => api.post(`/api/portal/income-tax/returns/${id}/submit`, { declaration: true, version }).then(d),
  itRespond: (id, iid, response) => api.post(`/api/portal/income-tax/returns/${id}/info-requests/${iid}/respond`, { response }).then(d),
  itRentalConfirm: (id, confirmed, note) => api.post(`/api/portal/income-tax/returns/${id}/rental-confirm`, { confirmed, note }).then(d),
  // client portal – BAS
  basEntities: () => api.get('/api/portal/bas-module').then(d),
  basGet: (pid) => api.get(`/api/portal/bas-module/periods/${pid}`).then(d),
  basDraft: (pid, body) => api.put(`/api/portal/bas-module/periods/${pid}/draft`, body).then(d),
  basUpload: (pid, file, fields) => api.post(`/api/portal/bas-module/periods/${pid}/upload`, form(file, fields)).then(d),
  basSubmit: (pid, version) => api.post(`/api/portal/bas-module/periods/${pid}/submit`, { declaration: true, version }).then(d),
  basXero: (pid) => api.post(`/api/portal/bas-module/periods/${pid}/xero-declaration`).then(d),
  basRespond: (pid, qid, response) => api.post(`/api/portal/bas-module/periods/${pid}/queries/${qid}/respond`, { response }).then(d),
  // practice
  staffIt: (cid) => api.get(`/api/income-tax/clients/${cid}`).then(d),
  staffItStart: (cid, fy) => api.post(`/api/income-tax/clients/${cid}/returns`, { financial_year: fy }).then(d),
  staffItStatus: (id, status, version, note) => api.post(`/api/income-tax/returns/${id}/status`, { status, version, note }).then(d),
  staffItReopen: (id, reason) => api.post(`/api/income-tax/returns/${id}/reopen`, { reason }).then(d),
  staffItInfo: (id, items) => api.post(`/api/income-tax/returns/${id}/info-requests`, { items }).then(d),
  staffItNote: (id, text) => api.post(`/api/income-tax/returns/${id}/notes`, { text }).then(d),
  staffBas: (cid) => api.get(`/api/bas/clients/${cid}`).then(d),
  staffBasPeriod: (pid) => api.get(`/api/bas/periods/${pid}`).then(d),
  staffGst: (cid, body) => api.put(`/api/bas/clients/${cid}/gst-settings`, body).then(d),
  staffInfoReceived: (pid) => api.post(`/api/bas/periods/${pid}/info-received`).then(d),
  staffQuery: (pid, text) => api.post(`/api/bas/periods/${pid}/queries`, { text }).then(d),
  staffBackfill: (cid, body) => api.post(`/api/bas/clients/${cid}/backfill`, body).then(d),
  lodge: (pid, body) => api.post(`/api/compliance-automation/periods/${pid}/lodgment`, body).then(d),
};

export const errText = (e) => {
  const x = e?.response?.data?.detail;
  if (Array.isArray(x)) return x.map((i) => String(i.msg || '').replace(/^Value error, /, '')).join('; ') || 'Please check the form';
  return typeof x === 'string' ? x : x?.message || 'Something went wrong';
};

// mirrors itr_questionnaire.visible (server is authoritative)
export const visible = (q, a) => {
  const c = q.show_if;
  if (!c) return true;
  const ok = ([k, v]) => (Array.isArray(v) ? v.includes(a[k]) : a[k] === v);
  return (c.all || []).every(ok) && (!c.any || c.any.some(ok));
};
